import angular from 'angular';
import _ from 'lodash';

import DiscardedIdentifier from '../data/seller/discarded-identifier.data';
import SubEntity from '../data/seller/sub-entity.data';
import BillingWarrant from '../data/seller/billing-warrant.data';

(function () {
    'use strict';
    angular.module('app.core').factory('SellersDA', SellersDA);

    SellersDA.$inject = [
        '$translate',
        'Restangular',
        'CONF',
        'Seller',
        'SellerBo',
        'SellerRelation',
        'ReportMyInvoice',
        'LegalEntity',
        'InvBuyerSubEntityRelation',
    ];

    /**
     * Accès à l'API concernant les fournisseurs (sellers)
     */

    /* @ngInject */
    function SellersDA(
        $translate,
        Restangular,
        CONF,
        Seller,
        SellerBo,
        SellerRelation,
        ReportMyInvoice,
        LegalEntity,
        InvBuyerSubEntityRelation
    ) {
        var version = 'v1';
        var baseUrl = 'sellers';

        var exports = {
            searchSellers: searchSellers,
            searchFiltredSellers: searchFiltredSellers,
            getSeller: getSeller,
            searchRelations: searchRelations,
            enableMyInvoice: enableMyInvoice,
            disableMyInvoice: disableMyInvoice,
            canEnableMyInvoice: canEnableMyInvoice,
            createUser: createUser,
            getDiscardedIdentifiers: getDiscardedIdentifiers,
            deleteDiscardedIdentifier: deleteDiscardedIdentifier,
            getSubEntities: getSubEntities,
            getDivisions: getDivisions,
            getBillingWarrants: getBillingWarrants,
            getSubEntityRelations: getSubEntityRelations,
            searchRelatedSubEntities: searchRelatedSubEntities,
            searchRelatedLegalEntities: searchRelatedLegalEntities,
            getSubEntity: getSubEntity,
        };

        return exports;

        ////////////////
        function searchSellers(searchValue) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .all(baseUrl)
                .post({ value: searchValue })
                .then(function (pageSellers) {
                    return _.map(pageSellers.content, function (s) {
                        return new Seller(s);
                    });
                });
        }

        function searchFiltredSellers(sellersFilter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .oneUrl(baseUrl)
                .all('filtred-search')
                .post(sellersFilter)
                .then(function (pageSellers) {
                    return {
                        totalItems: pageSellers.totalElements,
                        sellers: _.map(pageSellers.content, function (u) {
                            return new Seller(u);
                        }),
                    };
                });
        }

        /**
         * Récupère un utilisateur selon sonb login
         *
         * @param {string} sellerId - Identifiant du fournisseur.
         */
        function getSeller(sellerId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .oneUrl(baseUrl)
                .one(sellerId)
                .get()
                .then(function (sellerBo) {
                    return new SellerBo(sellerBo);
                });
        }

        /**
         * Récupère toutes les relations pour un fournisseur.
         *
         */
        function searchRelations(id, sellerRelationFilter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, id)
                .all('search-relations')
                .post(sellerRelationFilter)
                .then(function (relations) {
                    return _.map(relations, function (r) {
                        return new SellerRelation(r);
                    });
                });
        }

        /**
         * Activation de MyInvoice sur la relation Fournisseur / DO.
         *
         * @param {number} sellerId - identifiant du fournisseur.
         * @param {number} principalId - identifiant du DO.
         */
        function enableMyInvoice(sellerId, principalId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('principals', principalId)
                .one('myinvoice/enable')
                .customPUT();
        }

        /**
         * Désactivation de MyInvoice sur la relation Fournisseur / DO.
         *
         * @param {number} sellerId - identifiant du fournisseur.
         * @param {number} principalId - identifiant du DO.
         */
        function disableMyInvoice(sellerId, principalId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('principals', principalId)
                .one('myinvoice/disable')
                .customPUT();
        }

        /**
         * Test la si l'activation de MyInvoice sur la relation Fournisseur / DO est possible.
         *
         * @param {number} sellerId - identifiant du fournisseur.
         * @param {number} principalId - identifiant du DO.
         */
        function canEnableMyInvoice(sellerId, principalId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('principals', principalId)
                .one('myinvoice/can-enable')
                .get()
                .then(function (report) {
                    return new ReportMyInvoice(report);
                });
        }

        /**
         * Creation d'un utilisateur pour le fournisseur.
         * @param {number} sellerId - identifiant du fournisseur.
         * @param {json} user - les données de l'utilisateur à créer.
         */
        function createUser(sellerId, user) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .all('create-user')
                .post(user);
        }

        /**
         * Récupération des identifiants rejetés par le fournisseur.
         * @param {number} sellerId - identifiant du fournisseur.
         */
        function getDiscardedIdentifiers(sellerId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('discarded-identifiers')
                .get()
                .then(identifiers => _.map(identifiers, ident => new DiscardedIdentifier(ident, $translate)));
        }

        /**
         * Suppression d'un identifiant rejeté par le fournisseur.
         * @param {number} sellerId - identifiant du fournisseur.
         * @param {number} discardedIdentifierId - ID de l'identifiant à supprimer.
         */
        function deleteDiscardedIdentifier(sellerId, discardedIdentifierId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('discarded-identifiers', discardedIdentifierId)
                .remove();
        }

        /**
         * Récupère la liste des établissement d'une entité juridique.
         *
         * @param {string} legalEntityId - Identifiant de l'entité juridique.
         */
        function getSubEntities(legalEntityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity', legalEntityId)
                .oneUrl('sub-entity')
                .get()
                .then(function (subEntities) {
                    return _.map(subEntities, function (se) {
                        return new SubEntity(se, $translate);
                    });
                });
        }

        /**
         * Récupère la liste des divisions d'une entité juridique.
         *
         * @param {string} legalEntityId - Identifiant de l'entité juridique.
         */
        function getDivisions(legalEntityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity', legalEntityId)
                .oneUrl('divisions')
                .get()
                .then(function (subEntities) {
                    return _.map(subEntities, function (se) {
                        return new SubEntity(se, $translate);
                    });
                });
        }

        /**
         * Récupère la liste des relations établissement d'une entité juridique.
         *
         * @param {string} legalEntityId - Identifiant de l'entité juridique.
         */
        function getSubEntityRelations(subEntityId, invBuyerSubEntityRelationFilter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity/sub-entity', subEntityId)
                .all('relations')
                .post(invBuyerSubEntityRelationFilter)
                .then(function (relations) {
                    return _.map(relations, function (r) {
                        return new InvBuyerSubEntityRelation(r);
                    });
                });
        }

        function searchRelatedSubEntities(searchValue, subEntityd) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity/sub-entity', subEntityd)
                .all('related-sub_entites')
                .post({ value: searchValue })
                .then(function (subEntities) {
                    return _.map(subEntities, function (s) {
                        return new SubEntity(s);
                    });
                });
        }

        function searchRelatedLegalEntities(searchValue, subEntityd) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity/sub-entity', subEntityd)
                .all('related-legal_entites')
                .post({ value: searchValue })
                .then(function (legalEntities) {
                    return _.map(legalEntities, function (legalEntity) {
                        return new LegalEntity(legalEntity);
                    });
                });
        }

        /**
         * Récupère la liste des mandats de facturation d'un fournisseur.
         *
         * @param {string} sellerId - Identifiant du fournisseur.
         */
        function getBillingWarrants(sellerId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, sellerId)
                .one('billing-warrants')
                .get()
                .then(billingWarrants => _.map(billingWarrants, bw => new BillingWarrant(bw)));
        }

        function getSubEntity(subEntityId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('legal-entity/sub-entity', subEntityId)
                .get()
                .then(function (subEntity) {
                    return new SubEntity(subEntity);
                });
        }
    }
})();
